import { AxiosPromise } from 'axios';
import { ContactStatus, CreateContactStatusRequest } from '../../types/ContactStatus';
import { libApiInstance } from '../axios';

export function requestContactStatuses(signal?: AbortSignal): AxiosPromise<ContactStatus[]> {
    return libApiInstance.get('/contacts/statuses', { signal });
}

export function requestContactStatusById(
    statusId: number,
    signal?: AbortSignal,
): AxiosPromise<ContactStatus> {
    return libApiInstance.get(`/contacts/statuses/${statusId}`, { signal });
}

export function requestCreateContactStatus(
    data: CreateContactStatusRequest,
    signal?: AbortSignal,
): AxiosPromise<number> {
    return libApiInstance.post('/contacts/statuses', data, { signal });
}

export function requestUpdateContactStatus(
    data: CreateContactStatusRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.put(`/contacts/statuses/${data.statusId}`, data, {
        signal,
    });
}

export function requestDeleteContactStatus(
    statusId: number,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.delete(`/contacts/statuses/${statusId}`, { signal });
}

export function requestAssignContactStatus(
    statusId: number,
    contactIds: number[],
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.post(`/contacts/statuses/${statusId}/assign`, contactIds, { signal });
}

export function requestUnassignContactStatus(
    statusId: number,
    data: number[],
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.delete(`/contacts/statuses/${statusId}`, {
        signal,
        data: data,
    });
}
